import request from '@/utils/request'

// ========== 用户信息内存缓存（1秒内重复调用共享同一个请求）==========
let _userPromise = null
let _userCacheTime = 0

// ========== 小组列表内存缓存 ==========
let _groupPromise = null
let _groupCacheTime = 0

// ========== 足迹列表内存缓存 ==========
// ========== 足迹列表内存缓存（按 groupId 分开缓存）==========
const _footPromiseMap = new Map()  // key: groupId, value: { promise, time }

// 清空所有缓存（写操作后调用）
export function clearFootprintCache() {
  _userPromise = null
  _groupPromise = null
  _footPromiseMap.clear()
}

export async function getFootprintDetail(id) {
  const res = await request.get(`/footprint/detail/${id}`)
  return res.data || null
}


// ===================== 用户 =====================
export async function getCurrentUser() {
  if (!localStorage.getItem('token')) return {}
  const now = Date.now()
  // 1秒内重复调用直接返回同一个 promise
  if (_userPromise && now - _userCacheTime < 1000) {
    return _userPromise
  }
  _userCacheTime = now
  _userPromise = (async () => {
    try {
      const res = await request.get('/user/current')
      if (!res.success) return {}
      const user = res.user || {}
      const cached = JSON.parse(localStorage.getItem('currentUser') || '{}')
      user.currentGroupId = cached.currentGroupId || 'personal'
      if (cached.needRefreshMap !== undefined) {
        user.needRefreshMap = cached.needRefreshMap
      }
      return user
    } catch (err) {
      console.error('获取用户信息失败', err)
      return {}
    }
  })()
  return _userPromise
}

export async function setCurrentUser(user) {
  // 先把客户端状态写到 localStorage（currentGroupId、needRefreshMap、phone、groupIdList 等）
  const cached = JSON.parse(localStorage.getItem('currentUser') || '{}')
  const merged = { ...cached, ...user }
  localStorage.setItem('currentUser', JSON.stringify(merged))

  // 只有昵称/签名/头像这些"资料"字段才同步到后端
  if (user.nickname !== undefined || user.signature !== undefined || user.avatar !== undefined) {
    await request.put('/user/current', {
      nickname: user.nickname,
      signature: user.signature,
      avatar: user.avatar
    })
  }
  return merged
}

// ===================== 小组 =====================
export async function getGroupList() {
  const now = Date.now()
  if (_groupPromise && now - _groupCacheTime < 1000) {
    return _groupPromise
  }
  _groupCacheTime = now
  _groupPromise = (async () => {
    const res = await request.get('/group')
    return res.data || []
  })()
  return _groupPromise
}

export async function getMyGroupList() {
  const res = await request.get('/group/my')
  return res.data || []
}

export async function saveGroup(groupItem) {
  const res = await request.post('/group', groupItem)
  return res
}

export async function findGroupByInviteCode(inputCode) {
  const res = await request.get('/group')
  const code = inputCode.trim().toUpperCase()
  return (res.data || []).find(g => g.inviteCode?.toUpperCase() === code) || null
}

export async function joinGroupByInviteCode(targetGroup, userPhone) {
  const res = await request.post('/group/join', { inviteCode: targetGroup.inviteCode })
  return { success: res.success, msg: res.msg || '加入成功' }
}

// ===================== 足迹 =====================
export async function getFootprintList(groupId) {
  const key = groupId || '__all__'
  const now = Date.now()
  const cached = _footPromiseMap.get(key)
  if (cached && now - cached.time < 1000) {
    return cached.promise
  }
  const promise = (async () => {
    const params = {}
    if (groupId) params.groupId = groupId
    const res = await request.get('/footprint', { params })
    return res.data || []
  })()
  _footPromiseMap.set(key, { promise, time: now })
  return promise
}

export async function saveFootprint(record) {
  const res = await request.post('/footprint', record)
  return res
}

export async function delFootprint(recordId) {
  const res = await request.delete(`/footprint/${recordId}`)
  return res
}

export async function updateFootprint(recordId, newData) {
  const res = await request.put(`/footprint/${recordId}`, newData)
  return res
}

export async function getGroupFootprintList(groupId) {
  return getFootprintList(groupId)
}